module.exports = __webpack_public_path__ + "img/web1.1006440a.png";